import { render, staticRenderFns } from "./ArticleIndex.vue?vue&type=template&id=1cbb1e8d&scoped=true"
import script from "./ArticleIndex.vue?vue&type=script&lang=js"
export * from "./ArticleIndex.vue?vue&type=script&lang=js"
import style0 from "./ArticleIndex.vue?vue&type=style&index=0&id=1cbb1e8d&prod&lang=css"
import style1 from "./ArticleIndex.vue?vue&type=style&index=1&id=1cbb1e8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbb1e8d",
  null
  
)

export default component.exports